<div class="phone-input-wrap" [class.open]="dropdownOpen" [class.error]="hasError">
  <button
    type="button"
    class="phone-country-trigger"
    [attr.aria-expanded]="dropdownOpen"
    aria-haspopup="listbox"
    (click)="toggleDropdown($event)">
    <img class="phone-flag" [src]="flagUrl(selectedCountry.iso)" [alt]="selectedCountry.name" width="20" height="15" />
    <span class="phone-dial">{{ selectedCountry.dialCode }}</span>
    <svg class="phone-arrow" [class.rotated]="dropdownOpen" width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  <input
    class="phone-number-field"
    type="tel"
    [id]="inputId"
    [name]="name"
    [disabled]="disabled"
    [attr.maxlength]="12"
    [value]="value"
    (input)="onPhoneInput($event)"
    (keydown)="onPhoneKeydown($event)"
    (blur)="onBlur()"
    autocomplete="tel-national"
  />
  <div class="phone-country-menu" *ngIf="dropdownOpen" role="listbox">
    <input
      #searchInput
      type="text"
      class="phone-country-search"
      placeholder="Search country"
      [ngModel]="search"
      [ngModelOptions]="{standalone: true}"
      (ngModelChange)="onSearchChange($event)"
      (click)="$event.stopPropagation()"
      (keydown.escape)="$event.preventDefault(); closeDropdown()"
    />
    <button
      type="button"
      class="phone-country-option"
      *ngFor="let country of filteredCountries"
      [class.selected]="country.iso === selectedCountry.iso"
      (click)="selectCountry(country, $event)">
      <img class="phone-flag" [src]="flagUrl(country.iso)" [alt]="country.name" width="20" height="15" />
      <span class="phone-country-name">{{ country.name }}</span>
      <span class="phone-country-code">{{ country.dialCode }}</span>
    </button>
    <div class="phone-country-empty" *ngIf="filteredCountries.length === 0">No countries found</div>
  </div>
</div>
